import { render, staticRenderFns } from "./StatusUser.vue?vue&type=template&id=77fa7f90&"
import script from "./StatusUser.vue?vue&type=script&lang=js&"
export * from "./StatusUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports